export default "__VITE_ASSET__66b6fa08__"